module.exports = {"TXTCLI_Currency":{"id":"TXTCLI_Currency","defaultMessage":"Валюта","track":"Currency"}}